import { useRef } from 'react'
import { GlobalStorage } from '@feedyou/schema'
import { modal } from '@features/imperativeModals'

import { ModifyGlobalStorageModal } from '../components/ModifyGlobalStorageModal'
import { ModalFooterButton } from '../../../components/modals/styles'

export const useModifyGlobalStorageModal = (existingVariable: GlobalStorage | undefined) => {
  const submitButtonRef = useRef<HTMLButtonElement>()

  const openEditModal = () => {
    modal(({ onClose }) => ({
      title: existingVariable
        ? `Editing global storage ${existingVariable.name}`
        : `Adding new global storage`,
      loading: false,
      open: true,
      children: (
        <ModifyGlobalStorageModal
          onClose={onClose}
          submitButtonRef={submitButtonRef as any}
          existingVariable={existingVariable}
        />
      ),
      footer: (
        <>
          <ModalFooterButton label="Close" emphasis="secondary" onClick={() => onClose()} />
          <ModalFooterButton
            label="Save"
            emphasis="primary"
            onClick={() => submitButtonRef?.current?.click()}
          />
        </>
      ),
      modalStyle: { content: { height: 950, maxHeight: '94vh' } },
      modalContentStyle: { height: '100%', width: '100%', padding: 0 }
    }))
  }

  return { openEditModal }
}
